import { Box, Typography } from "@mui/material"

import Layout from "./Layout"
import Navigation from "./Navigation"
import Histories from "components/containers/Histories"
import useTranslation from "../../../hooks/use_translation"

const HistoryPage = () => {
  const { pages } = useTranslation()
  return (
    <Layout>
      <Box
        sx={{
          backgroundColor: "bg.light",
          p: 1,
          display: "flex",
          flexDirection: "column",
          mb: 6,
        }}
      >
        <Typography variant="h5" sx={{ mb: 2.5, fontWeight: 700 }}>
          {pages?.history_of_requests?.title}
        </Typography>

        <Histories />
      </Box>

      <Navigation />
    </Layout>
  )
}

export default HistoryPage
